import request from './request';
import exRequest from './exRequest';
import axios from 'axios';

//test
// let url = 'http://218.104.237.43:8000';
// formal
//let url = 'http://10.1.7.17:8800';

//HR工作台-预警提醒接口
export const GetEmplWarningDataApi = params =>
  request.post('/C_EMPLWARNING.v1/', params);
//HR工作台-证明列表
export const GetCertPrintListApi = params =>
  axios.get(url + '/emp/cert_print_list', params);
// //HR工作台-证明详情
export const GetCertPrintDetailApi = params =>
  axios.get(url + '/emp/cert_print_detail', params);
// //HR工作台-证明打印修改
export const CertPrintModifyApi = params =>
  axios.post(url + '/emp/cert_print_modify', params);
//员工简历
export const GetResumeDataApi = params =>
  request.post('C_EMPL_RESUME.v1/', params);

//证明开具基础信息
export const GetWorkDataApi = params =>
  request.post('/C_EMPL_PROVEINFO.v1/', params);
//收入证明开具
export const GetIncomeDataApi = params =>
  request.post('/C_EMPL_INCOME.v1/', params);
//在职，收入，居住证明开具提交
export const postZmkjDataApi = params =>
  request.post('/C_EMPL_PROVEPRINT.v1/', params);

//证明开具-查看证明历史列表
export const proveHistoryDataApi = params =>
  request.post('/C_EMPL_PROVE_SRCH.v1/', params);
//我的薪酬
export const GetMyIncomeDataApi = params =>
  request.post('/C_EMPL_SALARY_SRCH.v1/', params);
//我的薪酬二次查看密码
export const GetMyPwdDataApi = params =>
  request.post('/C_EMPL_SALARAY_PWD.v1/', params);
//我的薪酬变更
export const GetMyIncomeChangeDataApi = params =>
  request.post('/C_EMPL_MSG_SRCH.v1/', params);

//我的薪酬详情查看
export const GetMyIncomeDetailDataApi = params =>
  request.post('/C_EMPL_SALARY_DETAILS.v1/', params);
//修改密码
export const ChangePwdDataApi = params =>
  request.post('/C_EMPL_SALARY_UPDPWD.v1/', params);
//基础信息
export const getBasicMsgDataApi = params =>
  request.post('/C_EMPL_SRCH.v1/', params);

//员工考勤
export const getAttendDataApi = params =>
  request.post('/C_EMPL_ATTDANCEDETAILS.v1/', params);

//当天打卡数据
export const sameCalendarDataApi = params =>
  request.post('/C_CARDDATA_ACQ.v1/', params);
//日历
export const calendarDataApi = params =>
  request.post('/C_EMPL_CALENDAR.v1/', params);
//出差打卡异常
export const businessTripApi = params =>
  exRequest.post('/app/trip-move-record/month/list', params);

//值类型转换
export const changeDataApi = params =>
  request.post('/TRANSLATEVALUE.v1/', params);
//员工简历修改
export const changeResumeDataApi = params =>
  request.post('/C_EMPL_RESUME_UPD.v1/', params);
//员工简历修改手机验证码获取
export const smsPhoneDataApi = params =>
  request.post('/C_EMPL_GETSMS.v1/', params);
//薪资密码修改密码验证码获取
export const smsPhonePwdDataApi = params =>
  request.post('/C_EMPL_SALARY_MSG.v1/', params);
//薪资密码修改密码验证码获取
export const forgetPwdDataApi = params =>
  request.post('/C_EMPL_SALARY_VAL.v1/', params);

// 销假拆分接口信息
export const aparkRestDataApi = params =>
  request.post('/C_EMPL_BASRES.v1/', params);
//销假单据写入接口
export const cBalacneDataApi = params =>
  request.post('/C_BALANCE_APPLY.v1/', params);
//签卡单据写入接口
export const applicationDataApi = params =>
  request.post('/C_CARD_APPLY.v1/', params);

//验证接口
export const userIdDataApi = params =>
  request.post('/C_GET_PS_EMPLID.v1/', params);

//申请补卡记录
export const appRecordDataApi = params =>
  request.post('/C_EMPLCALH5.v1/', params);
//家庭信息删除接口
export const deleteMsgDataApi = params =>
  request.post('/C_EMPL_SOCI_DEL.v1/', params);

//文件传输接口
export const uploadDataApi = params =>
  request.post('/C_FILE_HANDLE.v1/', params);

//经理自且-我的团队考勤数据接口
export const GetMyTeamAttDataApi = params =>
  request.post('/DEPT_ATTENDANCE_H5.v1/', params);

//经理自助-我的团队考勤分析
export const getMyTeamCountApi = params =>
  request.post('/DEPT_ATTENDANCE_ANALYZE.v1/', params);

//经理自助- 团队下所有员工
export const getMyTeamIndexApi = params =>
  request.post('/C_EMPLALL_SRCH.v1/', params);
//经理自助-我的团队接口
export const GetMyTeamDataApi = params =>
  request.post('/DEPT_MEMBER.v1/', params);

//经理自助-我的团队-部门中子集的成员
export const getMyTeamsonDataApi = params =>
  request.post('/C_EMPL_SUB.v1/', params);

//经理自助-我的团队组织架构子部门
export const subDepartmentDataApi = params =>
  request.post('/DEPTORG_TREE.v1/', params);

//经理自助-我的团队部门下拉数据
export const getMyDeptDataApi = params =>
  request.post('/C_DEPT_LIST.v1/', params);

//经理自助-我的团队绩效
export const performanceDataApi = params =>
  request.post('/TEAMASSESSMENT.v1/', params);
//经理自助-我的团队人员绩效
export const detailformanceDataApi = params =>
  request.post('/C_EMPL_ASSESS.v1/', params);
//经理自助-我的团队分析
export const getTeamDeptData = params =>
  request.post('/MEMBER_ANALYZE.v1/', params);

//经理自助-团队奖励
export const getTeamrewardData = params =>
  request.post('/REWARD_INFO.v1/', params);

//经理自助-团队处分
export const getTeamPunishData = params =>
  request.post('/PUNISHMENT_INFO.v1/', params);

//经理自助-团队薪酬支付
export const getMyteampayDataApi = params =>
  request.post('/DEPT_SALARY_H5.v1/', params);

//经理自助-团队薪酬详情
export const getTeamSalaryData = params =>
  request.post('/DEPT_SAL_DETA_H5.v1/', params);

//经理自助-团队调薪
export const getTeamSalaryadjust = params =>
  request.post('/SALARY_REVISE.v1/', params);

//soa-login
export const userInfoIdDataApi = params =>
  request.post('/C_EMPL_BASIC.v1/', params);

// 绩效查询接口
export const getPerformancet = params =>
  request.post('/C_ASSESS_SRCH.v1/', params);
